import { inject, Injectable } from '@angular/core';
import { ActivatedRoute, ResolveStart, Router } from '@angular/router';
import { Params } from '@services/url/model/params';
import { filter, Observable, ReplaySubject } from 'rxjs';
import { tap } from 'rxjs/operators';

type urlDetails = { pathname: string; isPreview?: boolean };

@Injectable({
  providedIn: 'root',
})
export class UrlService {
  private readonly urlDetails$: ReplaySubject<urlDetails>;
  readonly #router = inject(Router);
  readonly #activatedRoute = inject(ActivatedRoute);

  constructor() {
    this.urlDetails$ = new ReplaySubject<urlDetails>(1);
  }

  monitoring(): void {
    this.#router.events
      .pipe(
        filter((e) => e instanceof ResolveStart),
        tap((e) => {
          const event: ResolveStart = e;
          const pathname = event.url.split('?')[0]!;
          const isPreview = event.url.includes('preview=');
          this.urlDetails$.next({ pathname, isPreview });
        })
      )
      .subscribe();
  }

  setUrlDetails(details: urlDetails): void {
    this.urlDetails$.next(details);
  }

  getUrlDetails$(): Observable<urlDetails> {
    return this.urlDetails$;
  }

  setParams(params: Params): void {
    void this.#router.navigate([], {
      relativeTo: this.#activatedRoute,
      queryParams: params,
      queryParamsHandling: 'merge',
    });
  }

  getParams(): Observable<Params> {
    return this.#activatedRoute.queryParams;
  }
}
